/**
 * @author Stefano Zina
 */

import IRealEstateSearchBean, {getDefaultSearchBean} from "./RealEstateSearchBean";

export interface ISaveSearchBeanOptions {
    active?: boolean;
    hourly?: boolean;
    title?: string;
    modified?: boolean;
}


export default interface ISaveSearchBean extends ISaveSearchBeanOptions {
    saveSearchParameterId: number | null;
    searchBean: IRealEstateSearchBean;
    searchUrl?: string;
    recentSearchUrl?: string;
    placeLabel?: string;
    realEstateCount?: number;
    recentRealEstateCount?: number;
    filtersLabels?: string[];
    latitude: number;
    longitude: number;
}


export function getDefaultSaveSearchBean(): ISaveSearchBean {
    return {
        active: true,
        hourly: false,
        latitude: 0,
        longitude: 0,
        saveSearchParameterId: null,
        searchBean: getDefaultSearchBean(),
        title: "",
    } as ISaveSearchBean;
}


export function getDefaultSaveSearchOptions(): ISaveSearchBeanOptions {
    return {
        active: false,
        hourly: false,
        title: "",
        modified: false
    } as ISaveSearchBeanOptions;
}